module.exports = __webpack_public_path__ + "static/media/kishu-character.1143d69d.png";